import React, {FC} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Label} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

interface Props {
  onBack: () => void
}

const Header: FC<Props> = ({onBack}) => {
  return (
    <Flex justifyContent="space-between">
      <Button id="settingsIntegration_OAUTH_back_button" tertiary onClick={onBack} marginBottom={2}>
        <Icon icon={IconTypes.arrowLeft} marginRight />
        <FormattedMessage id="platform.button.back" />
      </Button>
      <Label>
        <FormattedMessage id="admin.components.integration.sso.title" />
      </Label>
    </Flex>
  )
}

export default Header
